import dbee from '@os/dbee';
import { StorageNS, Preferences } from '../constants';

const getLocalTempUnit = storage => {
	let _store = storage || dbee(StorageNS.PREFERENCES);
	let tempUnit = _store.get(Preferences.TEMP_UNIT);
	return { weatherStore: _store, tempUnit };
};

const setLocalTempUnit = (tempUnit, storage) => {
	let _store = storage || dbee(StorageNS.PREFERENCES);
	_store.set(Preferences.TEMP_UNIT, tempUnit.toLowerCase());
	return { weatherStore: _store };
};

const localTempStore = {
	get: getLocalTempUnit,
	set: setLocalTempUnit
};

export default localTempStore;



// WEBPACK FOOTER //
// ../node_modules/@cube/weather-widget/src/lib/dbee-client.js